import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

function NotFoundPage() {
  return (
    <Box
      className="page-shell"
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Stack spacing={3} alignItems="center" textAlign="center">
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '4rem', md: '6rem' },
              fontWeight: 700,
              color: 'primary.main',
            }}
          >
            404
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            Page Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary">
            The page you're looking for doesn't exist or has been moved.
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            sx={{ mt: 2 }}
          >
            Back to Home
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}

export default NotFoundPage;
